// src/reasoningTests/ReasoningTestResultModal.js
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, IconButton, Typography, Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from 'react-i18next';

import ReasoningTestResult from "./ReasoningTestResult";

export default function ReasoningTestResultModal({ open, onClose, test }) {
    const { t } = useTranslation();

    const showEmpty = !test || !test.results;
    const testType = test?.testType;
    const hasReportUrl = test?.reportUrl;

    const getTestTitle = () => {
        const titles = {
            'numericalReasoning': t('reasoningTests.numericalReasoning'),
            'wordAssociation': t('reasoningTests.wordAssociation'),
            'logicalProcess': t('reasoningTests.logicalProcess'),
            'socialContext': t('reasoningTests.socialContext'),
            'logicalAbstract': t('reasoningTests.logicalAbstract'),
        };
        return titles[testType] || t('reasoningTests.title');
    };

    const handleDownloadReport = async () => {
        if (!hasReportUrl) return;

        try {
            const response = await fetch(test.reportUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `reporte-razonamiento-${test.applicantName || 'resultado'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error al descargar PDF:', error);
            // Fallback: abrir en nueva pestaña
            window.open(test.reportUrl, '_blank');
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    maxHeight: '90vh'
                }
            }}
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" component="span">
                        {getTestTitle()}
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                {showEmpty ? (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                        {t('reasoningTests.insufficientResponses')}
                    </Typography>
                ) : (
                    <ReasoningTestResult test={test} />
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                {hasReportUrl && (
                    <Button
                        variant="contained"
                        startIcon={<DownloadIcon />}
                        onClick={handleDownloadReport}
                        sx={{ mr: 'auto' }}
                    >
                        {t('reasoningTests.downloadReport')}
                    </Button>
                )}
                <Button onClick={onClose} variant="outlined">
                    {t('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}